<template>
    <div class="aldehyd-fehling">
        <p>
            Fehling I + II:
            <br />
            reduzierende Eigenschaft nachweisbar durch Bildung von ziegelrotem
            Kuper(I)oxid aus alkalischer Kuper(II)Sulfat-Lösung
            <br />
            Cu<sup>2+</sup> → Cu<sup>+</sup>
            <br />
            2 Cu<sup>2+</sup> + R-CHO + 5 OH<sup>-</sup> → Cu<sub>2</sub>O +
            RCOO<sup>-</sup> + 3 H<sub>2</sub>O
        </p>
    </div>
</template>

<script>
export default {
    name: 'aldehyd-fehling',
};
</script>
